export interface CalendarColor {
  id: string;
  name: string;
  bg: string;
  border: string;
  text: string;
}

export const CALENDAR_COLORS: CalendarColor[] = [
  { id: '1',  name: 'Lavender',  bg: '#e8eaf6', border: '#7986cb', text: '#3949ab' },
  { id: '2',  name: 'Sage',      bg: '#e0f2f1', border: '#33b679', text: '#00695c' },
  { id: '3',  name: 'Grape',     bg: '#f3e5f5', border: '#8e24aa', text: '#6a1b9a' },
  { id: '4',  name: 'Flamingo',  bg: '#fce4ec', border: '#e67c73', text: '#c62828' },
  { id: '5',  name: 'Banana',    bg: '#fffde7', border: '#f6bf26', text: '#f57f17' },
  { id: '6',  name: 'Tangerine', bg: '#fbe9e7', border: '#f4511e', text: '#bf360c' },
  { id: '7',  name: 'Peacock',   bg: '#e3f2fd', border: '#039be5', text: '#01579b' },
  { id: '8',  name: 'Graphite',  bg: '#eceff1', border: '#616161', text: '#212121' },
  { id: '9',  name: 'Blueberry', bg: '#e8eaf6', border: '#3f51b5', text: '#1a237e' },
  { id: '10', name: 'Basil',     bg: '#e8f5e9', border: '#0b8043', text: '#1b5e20' },
  { id: '11', name: 'Tomato',    bg: '#ffebee', border: '#d50000', text: '#b71c1c' },
];

export const DEFAULT_COLOR = { bg: '#e3f2fd', border: '#1976d2', text: '#0d47a1' };
const TENTATIVE_COLOR = { bg: '#f3e5f5', border: '#ab47bc', text: '#6a1b9a' };
const CANCELLED_COLOR = { bg: '#f5f5f5', border: '#9e9e9e', text: '#616161' };

export function getEventColor(colorId?: string | null, status?: string | null) {
  if (status === 'cancelled') return CANCELLED_COLOR;
  if (status === 'tentative' && !colorId) return TENTATIVE_COLOR;
  if (colorId) {
    const c = CALENDAR_COLORS.find((c) => c.id === colorId);
    if (c) return { bg: c.bg, border: c.border, text: c.text };
  }
  return DEFAULT_COLOR;
}
